import { useLiveQuery } from 'dexie-react-hooks';

import db from '../lib/db';

// Resolves the author to display for a message row. A live `profiles` row is preferred so
// renames and avatar changes show immediately, with the author snapshot embedded in the
// row as the fallback — that covers non-profile authors (bots/agents, which have no
// profiles row), deactivated or uncached profiles, and the first tick before the live
// query settles.
//
// `fallbackAuthor` exists because raw `feed_messages` rows carry no `author`: the feed
// attaches it when hydrating renderer rows, not when persisting. Callers that prefer the
// durable feed row over a retained renderer row pass the renderer row's author here so
// the snapshot survives that swap.
export function useMessageAuthor(message, workspaceId, fallbackAuthor = null) {
  const authorId = message?.author_id ?? null;
  const authorType = message?.author_type ?? null;

  const profileAuthor = useLiveQuery(
    () => {
      if (!authorId || authorType !== 'profile' || !workspaceId) return null;
      return db.profiles.get([workspaceId, authorId]);
    },
    [authorId, authorType, workspaceId],
    null,
  );

  return profileAuthor ?? message?.author ?? fallbackAuthor ?? null;
}
